import { ref } from "vue";
import { orders_api } from "boot/axios";

const available_dates = ref([]);
const get_available_dates = async function ({ brand, duns_number, meter_type }) {
  try {
    const { data } = await orders_api.get(`${process.env.VUE_APP_ORDER_SERVICE_URL}/api/available_dates`, {
      params: {
        brand,
        duns_number,
        meter_type
      },
      responseType: 'json'
    });
    return data;
  }
  catch (err) {
    throw err;
  }
}

export default () => {
  return {
    available_dates,
    get_available_dates
  }
};
